module.exports = __webpack_public_path__ + "static/media/Rock_08_UV_H_CM_1_normal.6085c2f7.jpg";